import { store, loading, computed, action } from '~/common/mobx.decorator'
import { SEARCH_JOB_QUERY } from '~/common/apollo/queries/jobs.query'
import { CollectionCursorStore } from '../collection.cursor.store'
import { mappingSkillName } from '~/common/helpers/mapping.helper'
import { omit } from 'lodash'

@store()
class AvailableJobStore extends CollectionCursorStore {
	constructor() {
		super(SEARCH_JOB_QUERY, 'searchJobs', ['totalCount'])
		this.name = 'availableJobStore'
	}

	@loading
	@action
	fetchData = (isReload, filterCondition, paging = {}, sortBy = { field: 'NEWEST', order: 'desc' }) => {
		const dataFilter = mappingSkillName(filterCondition)

		this.setSortBy(sortBy)

		return this.load(isReload, {
			filter: {
				...omit(dataFilter, ['locationStates', 'locationCities']),
			},
			...paging,
		})
	}

	@computed
	get totalCount() {
		return this.pageInfo.totalCount
	}
}

const availableJobStore = new AvailableJobStore()
export { availableJobStore, AvailableJobStore }
